import { v4 as uuidv4 } from 'uuid'

const data = [
  {
    id: uuidv4(),
    image: './images/groceries-1.jpg',
    title: 'Pilipili Hoho (Bell Pepper)',
  },
  {
    id: uuidv4(),
    image: './images/groceries-2.jpg',
    title: 'Assorted Groceries',
  },
  {
    id: uuidv4(),
    image: './images/groceries-3.jpg',
    title: 'Tomatoes',
  },
  {
    id: uuidv4(),
    image: './images/groceries-4.jpg',
    title: 'Lemons',
  },
  {
    id: uuidv4(),
    image: './images/groceries-5.jpg',
    title: 'Garlic',
  },
  {
    id: uuidv4(),
    image: './images/groceries-6.jpg',
    title: 'Red Onions',
  },
  {
    id: uuidv4(),
    image: './images/groceries-7.jpg',
    title: 'Capsicum',
  },
  {
    id: uuidv4(),
    image: './images/groceries-8.jpg',
    title: 'Maize',
  },
]

export default data
